import {useGetProtocol} from '@/modules/protocols/api/use-get-protocol'
import {Protocol} from '@cypro/engine/schema'
import {useGetProtocolActivities} from '@/modules/protocols/api/use-get-protocol-activities'
import {EventLog} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  protocol: Protocol
  activities: EventLog[] | undefined
}

interface Props extends PropsWithChildren {
  protocol: Protocol
}

const ProtocolContext = createContext<State>({} as State)

export function ProtocolProvider({children, protocol: initialProtocol}: Props) {
  const [protocol] = useGetProtocol(initialProtocol?.id)
  const [activities] = useGetProtocolActivities(initialProtocol?.id)

  return (
    <ProtocolContext.Provider value={{protocol: protocol || initialProtocol, activities}}>
      {children}
    </ProtocolContext.Provider>
  )
}

export function useProtocolContext() {
  return useContext(ProtocolContext)
}
